export default __webpack_public_path__ + "static/media/cs.92419d64.md";